import { ExternalConnection, ID } from '@griply/types';

import { canConnectionReadContacts } from './can-connection-read-contacts';

// Only connections granted the contacts scope are worth querying — for the rest the backend
// would answer with an empty list anyway (connections made before the scope was requested).
export const getContactsCapableConnectionIds = (
  connections: ExternalConnection[],
): ID[] => connections.filter(canConnectionReadContacts).map(({ id }) => id);
